import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import HeadingItem from '@atlaskit/menu/heading-item';
import Section from '@atlaskit/menu/section';

import { DevDocsConnectionRow } from './DevDocsConnectionRow.tsx';
import type { DevDocsBylineConnection } from './devDocsConnections.ts';

const i18n = defineMessages({
	syncedWith: {
		id: 'dev-docs.byline-connection.menu.section.synced-with.ai-non-final',
		defaultMessage: 'Synced with ({count, number})',
		description:
			'Section heading in the Teamwork Graph byline menu for content synced from a Dev Docs source. The count is the number of synced sources shown in the section.',
	},
});

export const DevDocsBylineConnectionMenuSection = ({
	connection,
	onNavigate,
}: {
	connection: DevDocsBylineConnection;
	onNavigate?: () => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Section>
			<HeadingItem>{formatMessage(i18n.syncedWith, { count: 1 })}</HeadingItem>
			<DevDocsConnectionRow connection={connection} onNavigate={onNavigate} />
		</Section>
	);
};
